import SearchResultItems from 'models/SearchResultItems';
import {
  ISearchApiCall,
  IRestApiService,
  SearchParams,
  ViewportParams,
  SeoSearchParams,
  MyStudiosOverviewParams,
  SearchResult,
} from '../types';

class SearchApiCall implements ISearchApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  seoRegions(culture: string): Promise<any> {
    return this.restApiService.get(`studios/seo-regions?culture=${culture}`);
  }

  getSearchResult(params: SearchParams): Promise<SearchResult> {
    const url = `studios?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}`;
    return this.restApiService.get(url);
  }

  suggest(value: string): Promise<string[]> {
    return this.restApiService.get(`studios/suggest?text=${value}`);
  }

  getSeoSearchResult(params: SeoSearchParams): Promise<{
    pagination: any;
    definedLocation: any;
    items: SearchResultItems[];
  }> {
    return this.restApiService.get(`studios/seo/${params.country}/${params.city}`).then((data: any) => {
      return {
        pagination: data.pagination,
        definedLocation: data.definedLocation,
        items: data.items.map((i: any) => new SearchResultItems(i)),
      };
    });
  }

  getSearchResultByViewport(params: ViewportParams): Promise<SearchResult> {
    const url = `studios/viewport`;
    return this.restApiService.post(url, params);
  }

  getMyStudios(all = false, withSchedule = false): Promise<{ items: any[] }> {
    const url = `studios/my?all=${all}&withSchedule=${withSchedule}`;
    return this.restApiService.get(url);
  }

  getMyStudiosOverview(params: MyStudiosOverviewParams): Promise<any> {
    const url = 'studios/my/overview';
    const urlParams = new URLSearchParams({
      limit: params.limit,
      offset: params.offset,
    });
    return this.restApiService.get(`${url}?${urlParams}`);
  }
}

export default SearchApiCall;
